import { AiOutlineDown } from "react-icons/ai";
import styles from "./GenerateKit.module.css";
import { HIGH_MAX } from "./constants";

export const ProductSplitAccordion = ({
  accordionOpen,
  setAccordionOpen,
  formData,
  productSplit,
  errors,
  updateLowMax,
  updateMediumMax,
  updateHighMin,
  updateRangePercentage,
}) => {
  return (
    <div className={styles.accordion}>
      <button
        type="button"
        className={styles.accordionHeader}
        onClick={() => setAccordionOpen((o) => !o)}
      >
        Product Splits & Budget Range
        <AiOutlineDown
          className={`${styles.accordionIcon} ${
            accordionOpen ? styles.open : ""
          }`}
        />
      </button>
      {accordionOpen && (
        <div className={styles.accordionBody}>
          {(errors.productSplit || errors.rangePercentage) && (
            <span className={styles.errorMessage}>
              {errors.productSplit || errors.rangePercentage}
            </span>
          )}
          <div className={styles.splitSection}>
            <div className={styles.splitLabel}>Price ranges (₹)</div>
            <div className={styles.splitRow}>
              <div className={styles.splitRowLabel}>
                Low (₹1 – ₹{productSplit.low.max})
              </div>
              <div className={styles.sliderRow}>
                <input
                  type="range"
                  className={styles.slider}
                  min={1}
                  max={HIGH_MAX - 2}
                  value={formData.lowMax}
                  onChange={(e) => updateLowMax(e.target.value)}
                />
                <input
                  type="number"
                  className={styles.sliderInput}
                  min={1}
                  max={HIGH_MAX - 2}
                  value={formData.lowMax}
                  onChange={(e) => updateLowMax(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.splitRow}>
              <div className={styles.splitRowLabel}>
                Medium (₹{productSplit.medium.min} – ₹
                {productSplit.medium.max})
              </div>
              <div className={styles.sliderRow}>
                <input
                  type="range"
                  className={styles.slider}
                  min={formData.lowMax + 2}
                  max={HIGH_MAX - 1}
                  value={formData.mediumMax}
                  onChange={(e) => updateMediumMax(e.target.value)}
                />
                <input
                  type="number"
                  className={styles.sliderInput}
                  min={formData.lowMax + 2}
                  max={HIGH_MAX - 1}
                  value={formData.mediumMax}
                  onChange={(e) => updateMediumMax(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.splitRow}>
              <div className={styles.splitRowLabel}>
                High (≥ ₹{productSplit.high.min})
              </div>
              <div className={styles.sliderRow}>
                <input
                  type="range"
                  className={styles.slider}
                  min={formData.mediumMax + 1}
                  max={HIGH_MAX}
                  value={formData.highMin}
                  onChange={(e) => updateHighMin(e.target.value)}
                />
                <input
                  type="number"
                  className={styles.sliderInput}
                  min={formData.mediumMax + 1}
                  max={HIGH_MAX}
                  value={formData.highMin}
                  onChange={(e) => updateHighMin(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className={styles.splitSection}>
            <div className={styles.splitLabel}>
              Budget flexibility (% over/under budget when finding products)
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className={styles.splitRow}>
                <div className={styles.splitRowLabel}>
                  Min % (under budget)
                </div>
                <div className={styles.sliderRow}>
                  <input
                    type="number"
                    className={styles.sliderInput}
                    min={0}
                    max={100}
                    value={formData.rangePercentage.min}
                    onChange={(e) =>
                      updateRangePercentage("min", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className={styles.splitRow}>
                <div className={styles.splitRowLabel}>
                  Max % (over budget)
                </div>
                <div className={styles.sliderRow}>
                  <input
                    type="number"
                    className={styles.sliderInput}
                    min={0}
                    max={100}
                    value={formData.rangePercentage.max}
                    onChange={(e) =>
                      updateRangePercentage("max", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
